import { createFeatureSelector, createSelector } from "@ngrx/store";

const selectDemandeLicencesFeature = createFeatureSelector<any>('demandeLicences');

export const selectAllDemandeLicence = createSelector(
  selectDemandeLicencesFeature,
  (state: any) => state
)